import { AnalyticsEntity, IAnalyticsUserInfo } from '../interfaces';

export function entityToLiveViewers(
  entity: AnalyticsEntity,
): IAnalyticsUserInfo[] {
  const { liveViewingUsers } = entity;
  if (!liveViewingUsers) return [];

  return Object.keys(liveViewingUsers).map((key) => liveViewingUsers[key]);
}
